export default __webpack_public_path__ + "static/media/check-routing-hint.55695f47.svg";